import React, {ChangeEvent, useState} from "react";
import {Partners} from "../../shared/partners";
import {env} from "../../environment";

export const ContactUs = () => {
    const [formDetails, setFormDetails] = useState({
        nameFirst: "",
        nameLast: "",
        email: "",
        phone: "",
        subject: "",
        message: "",
    });

    const onChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        setFormDetails(prevState => ({
            ...prevState,
            [name]: value,
        }));
    }

    return (
        <>
            <section data-bs-version="5.1" className="header3 cid-t9ZvkkvJxS mbr-parallax-background" id="header03-11">
                <div className="mbr-overlay" style={{ opacity: "0.4", backgroundColor: "rgb(0, 0, 0)" }}></div>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4 col-md-5 d-flex">
                            <div className="link-wrapper">
                                <p className="link mbr-fonts-style display-5">
                                    <strong>LET'S GET YOU MOVING</strong>
                                </p>
                                <span className="mbr-iconfont link-icon mobi-mbri-right mobi-mbri"></span>
                            </div>
                        </div>
                        <div className="col-12 col-lg-8 col-md-7">
                            <h1 className="mbr-section-title align-right mbr-fonts-style pb-5 mb-5 display-5">
                                <strong>We look forward to working with customers who </strong>
                                <br/>
                                <strong>pay attention to details and love high quality.&nbsp;</strong>
                                <strong><br/>We are happy to quote your project.</strong>
                                <br/>
                                <strong>
                                    We are {env.founderName?.split(" ").pop()}'s&nbsp;Builders.
                                </strong>
                            </h1>
                        </div>
                    </div>
                </div>
            </section>
            <section data-bs-version="5.1" className="contacts1 cid-taKydOxx17" id="contacts1-2p">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12 col-md">
                            <div className="text-wrapper">
                                <div className="header-text">
                                    <p className="label-text mbr-fonts-style display-7">
                                        <strong>CONTACT US</strong>
                                    </p>
                                    <h2 className="mbr-section-title mbr-fonts-style display-5">
                                        <strong>Get in touch today!</strong>
                                    </h2>
                                    <p className="mbr-text mbr-fonts-style display-4">
                                        We'd love to hear from you.
                                    </p>
                                </div>
                                <p className="contacts-text mbr-black mbr-fonts-style display-5">
                                    <strong>Phone:&nbsp;</strong>
                                    <a href={`tel:${env.supportPhone}`} className="text-primary">
                                        {env.supportPhone}
                                    </a>
                                    <br/><br/>
                                    <strong>Email:&nbsp;</strong>
                                    <a href={`mailto:${env.supportEmail}`} className="text-primary">
                                        {env.supportEmail}
                                    </a>
                                    <br/><br/>
                                    <strong>Working Hours:&nbsp;</strong>
                                    <br/>Mon - Fri: 8am - 6pm. <br/>Saturday: 9am - 4pm.
                                </p>
                            </div>
                        </div>
                        <div className="col-12 col-md-7 image-wrapper">
                            <img className="w-100 lazyload" alt="" loading="lazy"
                                 src="/images/arlington-research-kz8nhvg-tgi-unsplash-1283x856.jpg"
                                 data-src="/images/arlington-research-kz8nhvg-tgi-unsplash-1283x856.jpg"/>
                        </div>
                    </div>
                </div>
            </section>
            <section data-bs-version="5.1" className="form map2 therapym4_map2 cid-tbajWjQDYl" id="map2-2x"
                     data-rv-view="647">
            </section>
            <section data-bs-version="5.1" className="form map02 photom4_map02 cid-tbak3W6Pt0" id="map02-2z">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 col-md-12 pb-4 align-center col-sm-12">
                            <h5 className="mbr-fonts-style display-2">Send us a message!</h5>
                        </div>
                        <div className="col-md-12 col-lg-5">
                            <div className="google-map">
                                <iframe frameBorder="0" style={{ border: 0 }}
                                        src="https://www.google.com/maps/embed/v1/place?key=AIzaSyDk89J4FSunMF33ruMVWJaJht_Ro0kvoXs&amp;q=Firdonkatu 2, Workery West, 6th Floor,00520, Helsinki, Finland."
                                        allowFullScreen={true} loading="lazy" className="lazyload"
                                        data-src="https://www.google.com/maps/embed/v1/place?key=AIzaSyDk89J4FSunMF33ruMVWJaJht_Ro0kvoXs&amp;q=Firdonkatu 2, Workery West, 6th Floor,00520, Helsinki, Finland."></iframe>
                            </div>
                        </div>
                        <div className="col-md-12 col-lg-6 offset-md-1 mx-auto mbr-form" data-form-type="formoid">
                            <form action="https://formsubmit.co/philnurmi@hsconst.com" method="POST"
                                  className="mbr-form form-with-styler"
                                  data-form-title="Contact Us">
                                <div className="row">
                                    <div hidden={true} data-form-alert=""
                                         className="alert alert-success col-12">Thanks for filling out the form!
                                    </div>
                                    <div hidden={true} data-form-alert-danger=""
                                         className="alert alert-danger col-12">Oops...! some problem!
                                    </div>
                                </div>
                                <div className="dragArea row">
                                    <div className="col-lg-12 col-md-12 col-sm-12 form-group">
                                        <div className="row">
                                            <div className="col">
                                                <input type="text" name="nameFirst" placeholder="First Name"
                                                       data-form-field="nameFirst" onChange={onChange}
                                                       className="form-control text-multiple"
                                                       value={formDetails.nameFirst} id="nameFirst-map02-2z"/>
                                            </div>
                                            <div className="col">
                                                <input type="text" name="nameLast" placeholder="Last Name"
                                                       data-form-field="nameLast" onChange={onChange}
                                                       className="form-control text-multiple"
                                                       value={formDetails.nameLast} id="nameLast-map02-2z"/>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-12 col-sm-12 form-group mb-3" data-for="email">
                                        <input type="email" name="email" placeholder="Email" data-form-field="email"
                                               className="form-control display-7" value={formDetails.email}
                                               id="email-map02-2z" onChange={onChange}/>
                                    </div>
                                    <div data-for="phone" className="col-lg-6 col-md-12 col-sm-12 form-group mb-3">
                                        <input type="tel" name="phone" placeholder="Phone" data-form-field="phone"
                                               className="form-control display-7" pattern="*" value={formDetails.phone}
                                               id="phone-map02-2z" onChange={onChange}/>
                                    </div>
                                    <div data-for="subject"
                                         className="col-lg-12 col-md-12 col-sm-12 form-group mb-3">
                                        <input type="text" name="subject" placeholder="Subject"
                                               data-form-field="subject" className="form-control display-7"
                                               value={formDetails.subject} id="subject-map02-2z" onChange={onChange}/>
                                    </div>
                                    <div className="col-lg-12 col-md-12 col-sm-12 form-group mb-3"
                                         data-for="message">
                                        <textarea name="message" placeholder="Message" data-form-field="message"
                                                  className="form-control display-7" value={formDetails.message}
                                                  id="message-map02-2z" onChange={onChange}/>
                                    </div>
                                    <input type="hidden" name="_subject" value="Contact Form"/>
                                    <input type="hidden" name="_next" value="https://hsconst.com/contact-us"/>
                                    <div className="g-recaptcha"
                                         data-sitekey="6Le8dPspAAAAACFUlK01cHhCIM_g8PrO_NmI5OVT"
                                         data-action="LOGIN"></div>
                                    <div className="col-lg-12 col-md-12 col-sm-12 m-auto">
                                        <button type="submit"
                                                className="w-100 w-100 w-100 w-100 btn btn-black display-7">Send
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
            <Partners/>
        </>
    );
}
